// 申込（理由、日付）のストア

import { reactive } from "vue";
import aixos from 'axios';
import router from '../router';

export default function katudoMosikomi() {
	// 状態
	const katudom = reactive ({
		// 自分の階層
		kaiso: "",
		// 申込理由
		// 居住地に近い
		reason1: "0",
		// 活動内容が魅力的
		reason2: "0",
		// 交通の便が良い
		reason3: "0",
		// 活動期間
		reason4: "0",
		// 友人・知人
		reason5: "0",
		// その他
		reason6: "0",
		// その他（文章）
		sonota: "",

		// 申込日程（仮）
		nittei: [],

		// 募集ID
		// 一覧より選択して持ってくる
		bosyu_id: "",
		// 仮データ
		// bosyu_id: 4,
		
		// 活動者ID
		// ログイン情報より持ってくる
		katudosya_id: "",
		// 仮データ
		// katudosya_id: 4,

		// 状態コード
		jyotai_code: 0,

		
	});

	// その他が選択されていない時に、文章が入力されている場合
	const resetsonota = async () => {
		if(katudom.reason6 === "0") katudom.sonota = "";
	};

	// 新規登録
	const register = async (ID) => {
		makeArray(ID);
		try {
			const res = await aixos.post('/api/katudo_mosikomi/Add', katudo_mosikomi)
			console.log(res)
			router.push({ path: '/katudo-mosikomi/registered'});
			ResetKatudo();
		} catch(e) {
			console.log('error内容');
			console.log(e.response.status);

			let errorMessage = '';
			if (e.response && e.response.status) {
				switch (e.response.status) {
					case 500:
						errorMessage = 'サーバーエラーが発生しました。\n恐れ入りますが、時間をおいて再度お試しください。';
						break;
					default:
						errorMessage = '登録処理中にエラーが発生しました。\n青森市社会福祉協議会へお問合せください。\n(エラーコード：' + e.response.status + ')';
						break;
				}
			} else {
				errorMessage = 'ネットワークエラーが発生しました。\nインターネット接続をご確認の上、再度お試しください。';
			}
			return alert(errorMessage);
			// return alert('予期せぬエラーが発生しました。\n時間をおいて再度試してください。\n（エラーコード：' + e.response.status + '）');
		}
		// console
		// if (res && katudom.nittei) {
		// }
	};

	// 送信用空データ
	let katudo_mosikomi = [];
	// 配列作成
	const makeArray = async (ID) => {
		const LENG = katudom.nittei.length;
		for(var i = 0; i < LENG; i++) {
			katudo_mosikomi.push(
				{
					"katudosya_id": ID,
					"bosyu_id": Number(katudom.bosyu_id),
					"katudo_date": katudom.nittei[i],
					"riyu_kyojyu": Number(katudom.reason1),
					"riyu_naiyo": Number(katudom.reason2),
					"riyu_kotu": Number(katudom.reason3),
					"riyu_kikan": Number(katudom.reason4),
					"riyu_tijin": Number(katudom.reason5),
					"riyu_sonota": Number(katudom.reason6),
					"riyu_sonota_naiyo": katudom.sonota,
					"jyotai_code" : katudom.jyotai_code,
					"ukeire_kaiso": Number(katudom.kaiso)
				}
			);
		}
	};

	// 送信後リセット
	const ResetKatudo = async () => {
		katudom.reason1 = "0";
		katudom.reason2 = "0";
		katudom.reason3 = "0";
		katudom.reason4 = "0";
		katudom.reason5 = "0";
		katudom.reason6 = "0";
		katudom.sonota = "";
		katudom.nittei = [];
		katudom.bosyu_id = "";
		katudom.kaiso = "";
		katudo_mosikomi = [];
		// katudom.katudosya_id = "";
	}

	return {
		katudom,
		katudo_mosikomi,
		resetsonota,
		register,
		makeArray,
		ResetKatudo,
	}
}